import { css } from "styled-components";

export const TABLE_HEADER_COLOR = "#4a4a68";
export const TABLE_HEADER_FONT_SIZE = "13px";
export const TABLE_HEADER_FONT_WEIGHT = 600;
export const TABLE_HEADER_LINE_HEIGHT = "18px";

/** Canvas font string for measuring header text widths. */
export const TABLE_HEADER_MEASURE_FONT = `${TABLE_HEADER_FONT_WEIGHT} ${TABLE_HEADER_FONT_SIZE} Inter`;

export const tableHeaderTextCss = css`
  color: ${TABLE_HEADER_COLOR};
  font-size: ${TABLE_HEADER_FONT_SIZE};
  font-weight: ${TABLE_HEADER_FONT_WEIGHT};
  line-height: ${TABLE_HEADER_LINE_HEIGHT};
  text-transform: none;
`;

export const tableCellTextCss = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const tableNumericCss = css`
  font-variant-numeric: tabular-nums;
`;
